import { Box } from '@mui/material';
import cpaxLogoSvg from '../assets/cpax-logo.svg';

interface CpaxLogoProps {
  /** Overall height in pixels. Logo scales proportionally. */
  height?: number;
  /** 'default' = dark ink on light bg; 'light' = white on dark bg. */
  variant?: 'default' | 'light';
  /** Show the "Continuing Professional Education" tagline below the logo. */
  showTagline?: boolean;
  /** Show the full logo mark. Set false for a compact wordmark. */
  showMark?: boolean;
}

export default function CpaxLogo({
  height = 40,
  variant = 'default',
  showTagline = false,
  showMark = true,
}: CpaxLogoProps) {
  const logoHeight = showMark ? height : Math.round(height * 0.75);

  return (
    <Box sx={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <img
        src={cpaxLogoSvg}
        alt="CPAx Academy"
        height={logoHeight}
        style={{
          display: 'block',
          height: logoHeight,
          width: 'auto',
          ...(variant === 'light'
            ? { filter: 'brightness(0) invert(1)', opacity: 0.95 }
            : {}),
        }}
      />

      {showTagline && (
        <Box
          sx={{
            mt: `${Math.round(4 * (height / 40))}px`,
            display: 'flex',
            alignItems: 'center',
            gap: `${Math.round(8 * (height / 40))}px`,
            '&::before': {
              content: '""',
              flex: `0 0 ${Math.round(18 * (height / 40))}px`,
              height: '1.5px',
              background: '#cf7b28',
            },
          }}
        >
          <Box
            component="span"
            sx={{
              fontFamily: "'Manrope', sans-serif",
              fontWeight: 600,
              fontSize: `${(8.5 * (height / 40)).toFixed(1)}px`,
              letterSpacing: '0.28em',
              textTransform: 'uppercase',
              color: variant === 'light' ? 'rgba(255,255,255,0.55)' : '#6b7785',
              whiteSpace: 'nowrap',
            }}
          >
            Continuing Professional Education
          </Box>
        </Box>
      )}
    </Box>
  );
}
